import React from 'react';

import StreamTextDisplay from 'blockscope/components/aiSystem/panel/StreamTextDisplay';

// TODO: Make this more dynamic
const ErrorMessage = () => {
  return (
    <div className='error-message' style={{ color: 'red' }}>
      {/* Main message */}
      <div className='mb-3'>
        <StreamTextDisplay
          text={'Something went wrong while processing message'}
        />
      </div>
    </div>
  );
};

export default ErrorMessage;
